
import { useState } from "react";

export function useLessonCompletion(
  isLessonCompleted: boolean,
  onLessonComplete: () => Promise<any>
) {
  const [completionInProgress, setCompletionInProgress] = useState(false);

  const handleCompleteLesson = async () => {
    if (completionInProgress || isLessonCompleted) return;
    
    setCompletionInProgress(true);
    try {
      return await onLessonComplete();
    } finally {
      setCompletionInProgress(false);
    }
  };

  return {
    completionInProgress,
    handleCompleteLesson
  };
}
